import { render, staticRenderFns } from "./pageListNew.vue?vue&type=template&id=1cd5e9e6&scoped=true&"
import script from "./pageListNew.vue?vue&type=script&lang=js&"
export * from "./pageListNew.vue?vue&type=script&lang=js&"
import style0 from "./pageListNew.vue?vue&type=style&index=0&id=1cd5e9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5e9e6",
  null
  
)

export default component.exports